import { SITE_HEADER_HEIGHT, theme } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: ${theme.colors.GREY_90};
  width: 100%;
  height: 56vw;
  max-height: calc(85vh - ${SITE_HEADER_HEIGHT.small}px);

  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media ${theme.breakpoints.medium} {
    max-height: calc(85vh - ${SITE_HEADER_HEIGHT.medium}px);
  }

  @media ${theme.breakpoints.large} {
    max-height: calc(85vh - ${SITE_HEADER_HEIGHT.large}px);
  }
`
